<template>
    <strong class="o-ol"
        :ref="uid"
        :title="truncated_tooltip ? $options.filters.athT(uiTitle) : ''">
        {{ uiTitle | athT }}
    </strong>
</template>

<script>
import { guuid } from '@aretheyhappy/utils';

export default {
    name: 'mead-truncated-title',
    props: {
        /**
         * The title text to render, passed through the `athT` translation filter.
         * When the rendered text overflows its container, a native tooltip with
         * the full translated text is shown automatically.
         */
        uiTitle: {type: String, default: () => ''},
    },
    data () {
        return {
            uid: guuid(),
            truncated_tooltip: false,
        };
    },
    methods: {
        checkTruncation() {
            const el = this.$refs[this.uid];
            this.truncated_tooltip = el && el.scrollWidth > el.clientWidth;
        },
    },
    mounted() {
        this.checkTruncation();
        window.addEventListener('resize', this.checkTruncation);
    },
    destroyed () {
        window.removeEventListener('resize', this.checkTruncation);
    },
};
</script>
